export default {
  scheduled: {
    title: 'Estimado usuario.',
    description:
      'Nuestros servicios no están disponibles por el momento, volveremos a las {msg} hrs.',
    gratitude: '¡Gracias por tu preferencia!'
  },
  direct: {
    title: 'Estimado usuario.',
    description: 'Nuestros servicios no están disponibles por el momento.',
    gratitude: 'Puedes realizar la compra de recargas y paquetes en tu punto de venta mas cercano.'
  }
}
